import React, { memo } from 'react';
import { classNames } from '../../utils/classNames';

export const SegmentedControl = memo(function SegmentedControl({
	options = [],
	value,
	onChange,
	columns = 1,
	className,
}) {
	function select(optionValue) {
		if (!onChange) return;
		onChange(value === optionValue ? null : optionValue);
	}

	const gridClass =
		columns === 2
			? 'grid grid-cols-1 sm:grid-cols-2 gap-3'
			: columns === 3
				? 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3'
				: 'flex flex-col gap-3';

	return (
		<div className={classNames(gridClass, className)}>
			{options.map((option) => {
				const active = value === option.value;
				return (
					<button
						key={option.value}
						type='button'
						onClick={() => select(option.value)}
						className={classNames(
							'flex items-center gap-3 rounded-lg border bg-white px-3 py-2 text-left shadow-sm transition',
							active
								? 'border-sky-300 bg-sky-50/40 ring-2 ring-sky-200'
								: 'border-zinc-200 hover:border-zinc-300'
						)}
					>
						<span
							className={classNames(
								'inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full border transition',
								active
									? 'border-sky-500 bg-sky-500'
									: 'border-zinc-300 bg-white'
							)}
						>
							{active ? (
								<span className='h-1.5 w-1.5 rounded-full bg-white' />
							) : null}
						</span>
						<span className='text-sm font-medium text-zinc-800'>
							{option.label}
						</span>
						{option.description ? (
							<span className='text-xs text-zinc-400'>
								{option.description}
							</span>
						) : null}
					</button>
				);
			})}
		</div>
	);
});

export default SegmentedControl;